import styled from 'styled-components';

export const ActionsRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  position: relative;
  z-index: 5;
  justify-content: space-between;
  width: 100%;
  height: 100%;
`;

export const ButtonLabelBox = styled.div`
  padding: 0 14px;
`;
